import React, { PureComponent, Fragment } from 'react'
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  List,
  ListSubheader,
  ListItem,
  ListItemText
} from '@material-ui/core'

import { createDateFromDateId, createReadableDate, createDateFromTimestamp, createReadableTime } from 'services/helpers'

export class UserHistoryBase extends PureComponent {
  componentDidMount() {
    const { getUserHistory, data: { uid } } = this.props

    getUserHistory(uid)
  }

  // TODO: Put all transform logic to the selectors
  renderHistory = ({ id, lastSignInTime }) => {
    const { classes } = this.props

    const date = createDateFromDateId(id)
    const day = createReadableDate(date)

    return (
      <li 
        key={id}
        className={classes.listSection}
      >
        <ul className={classes.sublist}>
          <ListSubheader>{day}</ListSubheader>

          {lastSignInTime.map((item, i) => {
            const date = createDateFromTimestamp(item.seconds)
            const time = createReadableTime(date)

            return (
              <ListItem key={date} divider>
                <ListItemText primary={time} />
              </ListItem>
            )
          })}
        </ul>
      </li>
    )
  }

  render() {
    const { onClose, history, classes } = this.props

    return (
      <Fragment>
        <DialogTitle>Історія користувача</DialogTitle>

        <Divider />

        <DialogContent>
          <List
            dense
            className={classes.list}
          >
            {history.length
              ? history.map(this.renderHistory)
              : (
                <ListItem divider>
                  <ListItemText primary='Дані відсутні' />
                </ListItem>
              )}
          </List>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} color='primary'>
            Закрити
          </Button>
        </DialogActions>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/UserHistory/UserHistory.js